// 3 Series with hide/show on 1 Chart:
//   https://codesandbox.io/s/ef7p9?file=/src/BarChart.js

// history
//   https://echarts.apache.org/examples/en/editor.html?c=scatter-life-expectancy-timeline

// date range
//   https://echarts.apache.org/examples/en/editor.html?c=grid-multiple&lang=ts

// https://echarts.apache.org/examples/en/editor.html?c=multiple-y-axis
// https://echarts.apache.org/examples/en/editor.html?c=multiple-x-axis

// import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
// import alasql from "alasql";
//import Chart from '../../components/chart/Chart'
import ReactEcharts from "echarts-for-react";
import { toast } from "react-toastify";
import { BigNumber } from "@ethersproject/bignumber";

// import { DataGrid } from "@material-ui/data-grid";
// import { DeleteOutline } from "@material-ui/icons";
// import { productRows } from "../../dummyData";
// import Filter2Icon from "@mui/icons-material/Filter2";
// import Filter3Icon from "@mui/icons-material/Filter3";
import ShortTextIcon from "@mui/icons-material/ShortText";
import SubjectIcon from "@mui/icons-material/Subject";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import PriceCheckOutlinedIcon from "@mui/icons-material/PriceCheckOutlined";
import CancelPresentationOutlinedIcon from "@mui/icons-material/CancelPresentationOutlined";
import Button from "@mui/material/Button";
// import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
// import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import "./charts.css";
import { apiChartsUrl } from "../../config";
// import { FilterBlockchain } from "../../components/filters/Blockchain";
// import { MostAdvancedTable } from "../../components/reactTable/MostAdvancedTable";
// import {
//   tblColumns,
//   statsColumns,
// } from "../../components/reactTable/columnsYields";
import SetTitle from "../../components/setTitle/SetTitle";
import SplitButton from "../../components/mui/splitButton/SplitButton";
// import BasicSpeedDial from "../../components/mui/speedDial/SpeedDial";
// import CustomizedSwitches from "../../components/mui/switch/Switch";
import TermsMenuSelect from "../../components/intervalsMenu/TermsMenuSelect";
// import IntervalsMenu from "../../components/intervalsMenu/IntervalsMenu";
import IntervalsMenuSelect from "../../components/intervalsMenu/IntervalsMenuSelect";
import LinearDeterminate from "../../components/mui/progress/LinearDeterminate";
import { mysqlDate } from "../../components/common/date";
import { ColumnFilter } from "../../components/reactTable/ColumnFilter";
import HiddenBlock from "../../components/crudSql/hiddenBlock/HiddenBlock";
// import { walletShort } from "../../components/common/dataShort";
import AutocompleteAdd from "../../components/crudSql/autocompleteAdd/AutocompleteAdd";
import FormattedChartData from "./FormattedChartData";

export default function Charts({
  dateRange,
  setDateRange,
  intervalRange,
  setIntervalRange,
  userWallets,
  userAuthWallet,
}) {
  SetTitle("Charts @ DefiWatch.biz");

  const [isLoading, setIsLoading] = useState(true);

  const [defiData, setDefiData] = useState([]);
  const [graphData, setGraphData] = useState([]);
  const [graphDataSearch, setGraphDataSearch] = useState([]);

  // const [statsData, setStatsData] = useState([]);
  // const [vaults, setVaults] = useState([]);

  // const [dateRange, setDateRange] = useState("1M");

  const searchDefaultValsA = [{ title: "Manual" }];

  const toggleStatus = (e, id, closed) => {
    // console.log(e.target, id, closed);
    console.log(e.target.innerHTML, id, closed);

    Axios.post(process.env.REACT_APP_CRUD_SRV + "/vault/changeStatus", {
      id,
      closed: !closed,
      auth: userAuthWallet,
      cs: sha256(id + userAuthWallet + process.env.REACT_APP_SECRET).toString(),
    }).then(() => {
      // console.log("Vault status has been changed.");
      toast.success("Vault status has been changed.");

      // const graphDataModified = graphData.filter((v) => {
      //   return v.data3.id == id;
      // });
      // console.log("gdtm", graphDataModified);

      // if (e.target.innerHTML.indexOf("| Active") !== -1) {
      //   e.target.innerHTML = e.target.innerHTML = "| Closed";
      //   graphDataModified[0].data2.dna.closed = 1;
      //   graphDataModified[0].data3.dna.closed = 1;
      // } else {
      //   e.target.innerHTML = e.target.innerHTML = "| Active";
      //   graphDataModified[0].data2.dna.closed = 0;
      //   graphDataModified[0].data3.dna.closed = 0;
      // }
      // setGraphData(...graphData, graphDataModified[0]);

      if (e.target.innerHTML.indexOf("| Active") !== -1) {
        e.target.innerHTML = e.target.innerHTML = "| Closed";
      } else {
        e.target.innerHTML = e.target.innerHTML = "| Active";
      }
      graphData.forEach((row) => {
        if (row.data3.id == id) {
          row.data2.dna.closed = row.data2.dna.closed == 1 ? 0 : 1;
          row.data3.dna.closed = row.data3.dna.closed == 1 ? 0 : 1;
        }
      });
      // setGraphData(graphData);
      sortGraphData(graphData);
      setClosedVaultsCountByGraphData(graphData);
    });
  };

  const [chartType, setChartType] = useState(
    JSON.parse(localStorage.getItem("chartType")) ?? "data2"
  );
  // const handleChartTypeTglBtnGrp = (evt, newVal) => {
  //   setChartType(newVal);
  // };
  const handleChartType = (evt) => {
    // console.log("handleChartType", evt);
    setChartType(evt.target.value);
  };

  const [chartButtons, setChartButtons] = useState(
    JSON.parse(localStorage.getItem("chartButtons")) ?? true
  );
  // const handleChartButtons = (event) => {
  //   console.log(event.target.checked);
  //   setChartButtons(event.target.checked);
  // };

  const [search, setSearch] = useState(
    JSON.parse(localStorage.getItem("search")) ?? ""
  );
  const handleSearch = (event, newVal) => {
    // console.log(event.target.value, newVal);
    setSearch(event.target.value.trim());
  };

  const splitButtonOptions = [
    "Date Added", //0
    "Date Added",
    "BalAPR", //2
    "BalAPR",
    "TotAPR", //4
    "TotAPR",
    "Last BalAPR", //6
    "Last BalAPR",
    "Last Bal(ance)", //8
    "Last Bal",
    "Last Tot(al)", //10
    "Last Tot",
  ];
  // const splitButtonOptions = [
  //   "Date Added: High to Low",
  //   "Date Added: Low to High",
  //   "Latest APR: High to Low",
  //   "Latest APR: Low to High",
  //   "Latest Balance: High to Low",
  //   "Latest Balance: Low to High",
  //   "Latest Bal+Rewards, $: High to Low",
  //   "Latest Bal+Rewards, $: Low to High",
  // ];

  // const splitButtonOptions = [
  //   "Date Added: High to Low (HL)",
  //   "Date Added: Low to High (LH)",
  //   "Latest APR: HL",
  //   "Latest APR: LH",
  //   "Latest Balance: HL",
  //   "Latest Balance: LH",
  //   "Latest Bal+Rewards, $: HL",
  //   "Latest Bal+Rewards, $: LH",
  // ];
  const [sortByIndex, setSortByIndex] = useState(
    JSON.parse(localStorage.getItem("sortByIndex")) ?? 2
  );
  // const changeIndex = (index) => {
  //   setSortByIndex(index);
  // };

  const [status, setStatus] = useState(
    JSON.parse(localStorage.getItem("vaultStatus")) ?? 0
  ); //"All"
  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const [closedVaultsCount, setClosedVaultsCount] = useState(0);

  const location = useLocation();

  // filters __________________________________________________________________________
  const [walletsFilter, setWalletsFilter] = useState(
    JSON.parse(localStorage.getItem("walletsFilter")) ?? []
  );

  // const [userBlockchains, setUserBlockchains] = useState("");
  const [blockchainsFilter, setBlockchainsFilter] = useState(
    JSON.parse(localStorage.getItem("blockchainsFilter")) ?? []
  );
  const [platformsFilter, setPlatformsFilter] = useState(
    JSON.parse(localStorage.getItem("platformsFilter")) ?? []
  );
  // console.log("wallets", userWallets);

  const [balancesFilter, setBalancesFilter] = useState(
    JSON.parse(localStorage.getItem("balancesFilter")) ?? {
      bal0: false,
      bal1e18: false,
      bal1e17: true,
      bal1: true,
    }
  );
  const { bal0, bal1e18, bal1e17, bal1 } = balancesFilter;
  const handleChange = (event) => {
    setBalancesFilter({
      ...balancesFilter,
      [event.target.name]: event.target.checked,
    });
  };
  // /filters

  // local storage ____________________________________________________________________
  useEffect(() => {
    localStorage.setItem("chartType", JSON.stringify(chartType));
  }, [chartType]);

  useEffect(() => {
    localStorage.setItem("vaultStatus", JSON.stringify(status));
  }, [status]);

  useEffect(() => {
    localStorage.setItem("sortByIndex", JSON.stringify(sortByIndex));
  }, [sortByIndex]);

  useEffect(() => {
    localStorage.setItem("search", JSON.stringify(search));
  }, [search]);

  useEffect(() => {
    localStorage.setItem("chartButtons", JSON.stringify(chartButtons));
  }, [chartButtons]);

  useEffect(() => {
    localStorage.setItem("walletsFilter", JSON.stringify(walletsFilter));
  }, [walletsFilter]);

  useEffect(() => {
    localStorage.setItem(
      "blockchainsFilter",
      JSON.stringify(blockchainsFilter)
    );
  }, [blockchainsFilter]);

  useEffect(() => {
    localStorage.setItem("platformsFilter", JSON.stringify(platformsFilter));
  }, [platformsFilter]);

  useEffect(() => {
    localStorage.setItem("balancesFilter", JSON.stringify(balancesFilter));
  }, [balancesFilter]);

  // function localStorageGetItem(val, setVal) {
  //   const v = JSON.parse(localStorage.getItem(val));
  //   if (v) {
  //     setVal(v);
  //   }
  // }

  // useEffect(() => {
  //   const dateRange = JSON.parse(localStorage.getItem("dateRange"));
  //   if (dateRange) {
  //     setDateRange(dateRange);
  //   }

  //   const intervalRange = JSON.parse(localStorage.getItem("intervalRange"));
  //   if (intervalRange) {
  //     setIntervalRange(intervalRange);
  //   }

  //   localStorageGetItem("chartType", setChartType);
  // }, []);
  // /local storage

  // useEffect ________________________________________________________________________

  // /charts/402 -> 402 to search filter
  useEffect(() => {
    if (location && location.pathname.split("/").length == 3) {
      // console.log("location", location);
      let searchUrl = location.pathname.slice(
        location.pathname.lastIndexOf("/") + 1,
        location.pathname.length
      );
      setSearch(searchUrl);
    }
  }, [location]);

  useEffect(() => {
    // console.log("search", search);
    console.log(
      // walletsFilter,
      // blockchainsFilter,
      // platformsFilter,
      "balancesFilter=",
      balancesFilter
    );

    // if (search) {
    // const graphDataA = graphData.filter((v) => {
    const graphDataA = filterBalances(graphData).filter((v) => {
      const searchLowCase = search.toLowerCase();
      // фильтр отдновременно по статусу и по Search
      return (
        (status == "All" || status == v.data3.dna.closed) &&
        (walletsFilter.length === 0 ||
          walletsFilter.indexOf(v.wallet) !== -1) &&
        (blockchainsFilter.length === 0 ||
          blockchainsFilter.indexOf(v.blockchain) !== -1) &&
        (platformsFilter.length === 0 ||
          platformsFilter.indexOf(v.platform) !== -1) &&
        // (walletsFilter.length === 0 || walletsFilter.indexOf(v.wallet) !== -1) &&
        (search.length <= 2 ||
          v.data3.id?.toString().toLowerCase().includes(searchLowCase) ||
          v.data3.title.text?.toLowerCase().includes(searchLowCase) ||
          v.data3.title.subtext?.toLowerCase().includes(searchLowCase) ||
          v.data3.series[0].name?.toLowerCase().includes(searchLowCase) ||
          v.data3.dna.auto?.toLowerCase().includes(searchLowCase))
      );
    });
    setGraphDataSearch(graphDataA);
    // }

    // if (search.length > 2) {
    //   graphDataA = graphData.filter((v) => {
    //     const searchLowCase = search.toLowerCase();
    //     return (
    //       v.data3.id.toString().toLowerCase().includes(searchLowCase) ||
    //       v.data3.title.text.toLowerCase().includes(searchLowCase) ||
    //       v.data3.title.subtext.toLowerCase().includes(searchLowCase) ||
    //       v.data3.series[0].name.toLowerCase().includes(searchLowCase) ||
    //       v.data3.dna.auto.toLowerCase().includes(searchLowCase)
    //     );
    //   });
    //   setGraphDataSearch(graphDataA);
    // } else setGraphDataSearch(graphData);
  }, [
    search,
    status,
    graphData,
    walletsFilter,
    blockchainsFilter,
    platformsFilter,
    balancesFilter,
  ]);

  // log
  // useEffect(() => {
  //   console.log("gd", graphData);
  // }, [graphData]);

  // useEffect(() => {
  //   console.log("gds", graphDataSearch);
  // }, [graphDataSearch]);
  // /log

  useEffect(() => {
    sortGraphData(graphData);
  }, [sortByIndex]);

  useEffect(() => {
    const getDefiData = async () => {
      try {
        setIsLoading(true);

        const url =
          apiChartsUrl +
          dateRange +
          "?interval=" +
          intervalRange +
          "&auth=" +
          userAuthWallet +
          "&cs=" +
          sha256(userAuthWallet + process.env.REACT_APP_SECRET).toString();
        if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);

        const res = await Axios.get(url, {
          /*headers: {
            token:
            "Bearer "+JSON.parse(localStorage.getItem("user")).accessToken,
          },*/
        });

        if (res.status != 200) {
          // console.log("Error receiving charts data!");
          toast.error("Error receiving charts data!");
          return;
        }

        const optionA = Object.values(res.data.response)
          // .filter((row) => {
          //   // показываем только графики у которых есть хотя бы один ненулевой баланс
          //   let nonZeroBalA = row.balA.filter(
          //     (bal) => bal != 0 && bal !== "1e-18"
          //   );
          //   let nonZeroTotalUsdA = row.totalUsdA.filter(
          //     (bal) => bal != 0 && bal !== "1e-18"
          //   );
          //   if (nonZeroBalA.length > 0 || nonZeroTotalUsdA.length > 0) {
          //     // console.log(nonZeroBalA);
          //     return row;
          //   }
          // })
          .map((v) => {
            return FormattedChartData(v);
          });
        // console.log("optionA", optionA);

        sortGraphData(optionA);
        setClosedVaultsCountByGraphData(optionA);
        // const closedVaults = optionA.filter((v) => v.data2.dna.closed == 1);
        // setClosedVaultsCount(closedVaults.length);

        // const blockchains = [
        //   ...new Set(
        //     Object.values(res.data.response).map(
        //       (item) => item.titles.Blockchain
        //     )
        //   ),
        // ];
        // setUserBlockchains(blockchains);

        setIsLoading(false);
      } catch (err) {
        console.log(err);
      }
    };

    if (userAuthWallet && dateRange && intervalRange) getDefiData();
  }, [userAuthWallet, dateRange, intervalRange]);

  const filterBalances = (graphDataFull) => {
    let graphData = [];
    if (bal0 && bal1e18 && bal1e17 && bal1) {
      // показывать все - и 0 и 1e18 ...
      graphData = [...graphDataFull];
    } else {
      graphData = graphDataFull.filter((row) => {
        // показываем только графики у которых есть хотя бы один ненулевой баланс
        const nonZeroBalA = row.data3.series[0].data.filter(
          // balA
          // (bal) => (bal0 || bal != 0) && (bal1e18 || bal !== "1e-18")
          (bal) => {
            // const balBigN = BigNumber.from(bal);
            const balBigN = +bal;
            // prettier-ignore
            // console.log("balA=", bal, balBigN,
            //   "bal0=", bal0, bal == 0,
            //   "bal1e18=", bal1e18, bal.indexOf("e-18") !== -1,
            //   "bal1e17=", bal1e17,  balBigN >= 1e-17 && balBigN < 1,
            //   "bal1=", bal1, balBigN > 1
            // );
            return (
              // (bal0 && bal == 0) ||
              // (bal1e18 && bal.indexOf("e-18") !== -1) ||
              // (bal1e17 && balBigN.gte(1e-17) && balBigN.lt(1)) ||
              // (bal1 && balBigN.gte(1))
              (bal0 && bal == 0) ||
              (bal1e18 && bal.indexOf("e-18") !== -1) ||
              (bal1e17 && balBigN >= 1e-17 && balBigN < 1) ||
              (bal1 && balBigN >= 1)
            );
          }
        );
        // const nonZeroTotalUsdA = row.data3.series[2].data.filter(
        //   // totalUsdA
        //   // (bal) => (bal0 || bal != 0) && (bal1e18 || bal !== "1e-18")
        //   (bal) => {
        //     // const balBigN = BigNumber.from(bal);
        //     const balBigN = +bal;
        //     return (
        //       // (bal0 || bal != 0) && (bal1e18 || bal.indexOf("e-18") === -1)
        //       (bal0 && bal == 0) ||
        //       (bal1e18 && bal.indexOf("e-18") !== -1) ||
        //       (bal1e17 && balBigN >= 1e-17 && balBigN < 1) ||
        //       (bal1 && balBigN >= 1)
        //     );
        //   }
        // );
        const nonZeroTotalUsdA = [];
        if (nonZeroBalA.length > 0 || nonZeroTotalUsdA.length > 0) {
          // console.log(nonZeroBalA);
          return row;
        }
      });
      // .map((v) => {
      //   return FormattedChartData(v);
      // })
    }
    // console.log(graphData, graphDataFull);

    return graphData;
  };

  const sortGraphData = (graphData) => {
    // const graphData = filterBalances(graphDataFull);

    let sortedA = [];
    //TODO: 0 & 1 sortByIndex считаются по волтам, а должны по дате баланса
    if (sortByIndex == 0) {
      // Date Added: High to Low
      // 👇️ sort by String property DESCENDING (Z - A)
      sortedA = [...graphData].sort(
        (a, b) =>
          // a.data3.dna.sortNo > b.data3.dna.sortNo ? -1 : 1
          // b.data3.dna.sortNo - a.data3.dna.sortNo
          b.data3.id - a.data3.id
      );
    } else if (sortByIndex == 1) {
      // 👇️ sort by String property ASCENDING (A - Z)
      sortedA = [...graphData].sort(
        (a, b) =>
          // a.data3.dna.sortNo > b.data3.dna.sortNo ? 1 : -1
          // a.data3.dna.sortNo - b.data3.dna.sortNo
          a.data3.id - b.data3.id
      );
    } else if (sortByIndex == 2) {
      // BalAPR: High to Low
      sortedA = [...graphData].sort(
        (a, b) => b.data3.dna.balanceApr - a.data3.dna.balanceApr
      );
    } else if (sortByIndex == 3) {
      sortedA = [...graphData].sort(
        (a, b) => a.data3.dna.balanceApr - b.data3.dna.balanceApr
      );
    } else if (sortByIndex == 4) {
      // TotAPR: High to Low
      sortedA = [...graphData].sort(
        (a, b) => b.data3.dna.totalApr - a.data3.dna.totalApr
      );
    } else if (sortByIndex == 5) {
      sortedA = [...graphData].sort(
        (a, b) => a.data3.dna.totalApr - b.data3.dna.totalApr
      );
    } else if (sortByIndex == 6) {
      // Last BalAPR: High to Low
      // 👇️ sort by Numeric property DESCENDING (100 - 1)
      sortedA = [...graphData].sort(
        (a, b) =>
          b.data3.series[1].data[b.data3.series[1].data.length - 1] -
          a.data3.series[1].data[a.data3.series[1].data.length - 1]
      );
    } else if (sortByIndex == 7) {
      // 👇️ sort by Numeric property ASCENDING (1 - 100)
      sortedA = [...graphData].sort(
        (a, b) =>
          a.data3.series[1].data[a.data3.series[1].data.length - 1] -
          b.data3.series[1].data[b.data3.series[1].data.length - 1]
      );
    } else if (sortByIndex == 8) {
      // Balance: High to Low
      sortedA = [...graphData].sort(
        (a, b) =>
          b.data3.series[0].data[b.data3.series[0].data.length - 1] -
          a.data3.series[0].data[a.data3.series[0].data.length - 1]
      );
    } else if (sortByIndex == 9) {
      sortedA = [...graphData].sort(
        (a, b) =>
          a.data3.series[0].data[a.data3.series[0].data.length - 1] -
          b.data3.series[0].data[b.data3.series[0].data.length - 1]
      );
    } else if (sortByIndex == 10) {
      // Bal+Rewards: High to Low
      sortedA = [...graphData].sort(
        (a, b) =>
          b.data3.series[2].data[b.data3.series[2].data.length - 1] -
          a.data3.series[2].data[a.data3.series[2].data.length - 1]
      );
    } else if (sortByIndex == 11) {
      sortedA = [...graphData].sort(
        (a, b) =>
          a.data3.series[2].data[a.data3.series[2].data.length - 1] -
          b.data3.series[2].data[b.data3.series[2].data.length - 1]
      );
    }

    if (sortedA.length > 0) {
      // console.log("sortedA", sortByIndex, sortedA);
      setGraphData(sortedA);
    }
  };

  function setClosedVaultsCountByGraphData(optionA) {
    const closedVaults = optionA.filter((v) => v.data2.dna.closed == 1);
    setClosedVaultsCount(closedVaults.length);
  }

  // console.log(graphData, getName, getVal1);
  // console.log(statsData, vaults);

  // if (!userAuthWallet) return <h2>Please connect your wallet to Metamask</h2>;

  return (
    <div className="page chartsPage">
      {/*graphData['2021-Sep-18 06:28:00'][0]['Dt']*/}
      {/*<Chart data={userData} title="User Analytics" grid dataKey="Active User"/>*/}
      {/*<FilterBlockchain supportedTokens={supportedTokens} />*/}

      {/* <div>{graphData[0].title.subtext}</div> */}

      <div className="topSubMenu">
        <h1>Charts</h1>

        <div className="topSubMenuBlock">
          {/* <IntervalsMenu dateRange={dateRange} setDateRange={setDateRange} /> */}
          <TermsMenuSelect dateRange={dateRange} setDateRange={setDateRange} />

          <IntervalsMenuSelect
            dateRange={intervalRange}
            setDateRange={setIntervalRange}
            termRange={dateRange}
          />
        </div>

        <div className="topSubMenuBlock">
          {/* 2 кнопки рядом: Basic/Detailed Charts */}
          {/* <ToggleButtonGroup
            value={chartType}
            exclusive
            onChange={handleChartTypeTglBtnGrp}
            aria-label="int chartType"
            size="small"
            className="extraSmall"
            tyle={{ marginRight: 10 }}
          >
            <ToggleButton value="data2" aria-label="data2">
              <Tooltip title="Basic Charts">
                <ShortTextIcon />
              </Tooltip>
            </ToggleButton>
            <ToggleButton value="data3" aria-label="data3">
              <Tooltip title="Detailed Charts">
                <SubjectIcon />
              </Tooltip>
            </ToggleButton>
          </ToggleButtonGroup> */}

          <FormControl
            variant="standard"
            sx={{ m: 1, minWidth: 120 }}
            className="vaultStatusMenu extraSmall"
          >
            <InputLabel id="select-standard-label">Chart Type</InputLabel>
            <Select
              labelId="select-standard-label"
              id="select-standard"
              value={chartType}
              onChange={handleChartType}
              label="Status"
            >
              <MenuItem value="data2">Bal, APR</MenuItem>
              <MenuItem value="data3">Bal, APR, Bal$+Rwds$</MenuItem>
              <MenuItem value="data3Borw" disabled>
                Bal, APR, Bal$+Rwds$+Borw$ (Q4 2022)
              </MenuItem>
              <MenuItem value="balMinMax" disabled>
                Bal MIN & MAX (Q4 2022)
              </MenuItem>
            </Select>
          </FormControl>

          <FormControl
            variant="standard"
            sx={{ m: 1, minWidth: 120 }}
            className="vaultStatusMenu extraSmall"
          >
            <InputLabel id="select-standard-label">Vault Status</InputLabel>
            <Select
              labelId="select-standard-label"
              id="select-standard"
              value={status}
              onChange={handleStatusChange}
              label="Status"
            >
              <MenuItem value="All">
                {/* <em>All</em> */}
                All ({graphData.length})
              </MenuItem>
              {/* <MenuItem value={10}>Ten</MenuItem> */}
              <MenuItem value={0}>
                Active ({graphData.length - closedVaultsCount})
              </MenuItem>
              <MenuItem value={1}>Closed ({closedVaultsCount})</MenuItem>
            </Select>
          </FormControl>

          <span className="sortBy">
            <label>Sort by </label>
            <SplitButton
              options={splitButtonOptions}
              selectedIndex={sortByIndex}
              setSelectedIndex={setSortByIndex}
            />
          </span>

          {/* <SearchOutlinedIcon /> */}
          <input
            type="text"
            placeholder="Search..."
            className="extraSmall search"
            value={search}
            onChange={handleSearch}
          />
          {/* <AutocompleteAdd
            name="platform"
            value={search}
            className="extraSmall search searchAutocomplete"
            data={searchDefaultValsA}
            label="Search..."
            onChg={handleSearch}
            required
          /> */}

          <HiddenBlock title="More" className="chartsFilters">
            <ColumnFilter
              column={{
                Header: "Wallets",
                id: "wallet",
                filterType: "select",
                filterValue: walletsFilter,
                setFilter: setWalletsFilter,
              }}
              data={graphData}
            />

            <ColumnFilter
              column={{
                Header: "Blockchains",
                id: "blockchain",
                filterType: "select",
                filterValue: blockchainsFilter,
                setFilter: setBlockchainsFilter,
              }}
              data={graphData}
            />

            <ColumnFilter
              column={{
                Header: "Platforms",
                id: "platform",
                filterType: "select",
                filterValue: platformsFilter,
                setFilter: setPlatformsFilter,
              }}
              data={graphData}
            />
            {/* <Select
            filter={setFilter}
            name="walletsFilter"
            values={userWallets}
          /> */}
            {/* </div> */}

            {/* <Checkbox /> */}
            <FormControlLabel
              control={
                <Checkbox checked={bal1} onChange={handleChange} name="bal1" />
              }
              label="Show bal >=1"
              labelPlacement="top"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={bal1e17}
                  onChange={handleChange}
                  name="bal1e17"
                />
              }
              label=">=1e-17 & <1"
              labelPlacement="top"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={bal1e18}
                  onChange={handleChange}
                  name="bal1e18"
                />
              }
              label="<=1e-18"
              labelPlacement="top"
            />
            {/* <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={bal0}
                    onChange={handleChange}
                    name="bal0"
                  />
                }
                label="=0"
              />
            </FormGroup> */}
          </HiddenBlock>
        </div>

        <div className="topSubMenuBlock">
          <Tooltip title="Toggle chart buttons">
            <ToggleButton
              value="check"
              selected={chartButtons}
              onChange={() => {
                setChartButtons(!chartButtons);
              }}
              size="small"
              className="extraSmall"
            >
              {chartButtons ? (
                <VisibilityOutlinedIcon />
              ) : (
                <VisibilityOffOutlinedIcon />
              )}
            </ToggleButton>
          </Tooltip>

          <Link to="/vaults" className="link">
            <Button
              variant="outlined"
              className="extraSmall"
              // startIcon={<LocalAtmOutlinedIcon />}
            >
              Add Vault
            </Button>
          </Link>

          {/* <Switch label="Gilad Gray" defaultChecked /> */}
          {/* <FormControlLabel
            control={
              <Checkbox
                checked={chartButtons}
                onChange={handleChartButtons}
                color="success"
              />
            }
            label="Chart Buttons"
            className="extraSmall cbChartButtons"
          /> */}
        </div>

        {/* <SearchOutlinedIcon /> */}
        {/* <input
          type="text"
          placeholder="Search..."
          className="extraSmall search"
          value={search}
          onChange={handleSearch}
        /> */}
      </div>

      {/* {isLoading ? <h2>Loading...</h2> : <></>} */}
      {isLoading ? <LinearDeterminate /> : <></>}

      {/* {!userAuthWallet ? (
        <h2>Please connect your wallet to Metamask</h2>
      ) : isLoading ? (
        <h2>Loading...</h2>
      ) : (
        ""
      )} */}

      <div className={"echartContainer " + chartType}>
        {graphDataSearch.map((option) => {
          // console.log(option);
          // [chartType] == "data2" or "data3"
          return (
            <div key={option[chartType].id}>
              <ReactEcharts
                option={option[chartType]}
                notMerge="true"
                className="echart"
                // key={option[chartType].id}
              />
              {/* <BasicSpeedDial /> */}
              <div className="vaultPerformance">
                {/* Date1 - Date2: {option[chartType].xAxis.data[0]} -{" "}
                {
                  option[chartType].xAxis.data[
                    option[chartType].xAxis.data.length - 1
                  ]
                }
                {": "} */}
                {option[chartType].dna.daysBetween +
                  " days, BalAPR = " +
                  +(+option[chartType].dna.balanceApr).toFixed(1) +
                  "%" +
                  ", TotAPR = " +
                  +(+option[chartType].dna.totalApr).toFixed(1) +
                  "%"}
              </div>
              {chartButtons ? (
                <div className="divEchartButtons">
                  {option[chartType].dna.auto == "Auto" ? (
                    ""
                  ) : (
                    <>
                      <label
                        className={
                          "vaultBadge vault" + option[chartType].dna.auto
                        }
                      >
                        {option[chartType].dna.auto}
                      </label>
                      <Link
                        // to={"/vaults/add/balance/" + option[chartType].id}
                        to={
                          "/vaults/add/balance/" +
                          option.walletLong +
                          "/" +
                          option[chartType].id
                        }
                        className="chartBtn"
                      >
                        <Tooltip
                          title="Add Balance & Rewards"
                          style={{ marginRight: 10 }}
                        >
                          <LocalAtmOutlinedIcon />
                        </Tooltip>
                      </Link>
                    </>
                  )}

                  <Tooltip title="Add Deposit">
                    <Link
                      to={"/vaults/deposit/" + option[chartType].id}
                      className="chartBtn"
                    >
                      <AddCardOutlinedIcon />
                    </Link>
                  </Tooltip>

                  <Tooltip title="Add Claim">
                    <Link
                      to={"/vaults/claim/" + option[chartType].id}
                      className="chartBtn"
                    >
                      <PriceCheckOutlinedIcon />
                    </Link>
                  </Tooltip>

                  {/* <Tooltip title="Add Withdraw"> */}
                  {/*   <CancelPresentationOutlinedIcon className="dimLink" /> */}
                  {/*   <img src="/images/rmCard.png" className="withdrawBtn"/>
                  </Tooltip> */}
                  <Tooltip title="Add Withdraw">
                    <Link
                      to={"/vaults/withdraw/" + option[chartType].id}
                      className="chartBtn"
                    >
                      <img src="/images/rmCard.png" className="withdrawBtn" />
                    </Link>
                  </Tooltip>

                  <Tooltip title="Toggle Status">
                    <span
                      className={
                        "vaultStatusLink" +
                        (option[chartType].dna.closed
                          ? " vaultStatusClosed"
                          : "")
                      }
                      onClick={(e) =>
                        toggleStatus(
                          e,
                          option[chartType].id,
                          option[chartType].dna.closed
                        )
                      }
                    >
                      |{" "}
                      {option[chartType].dna.closed
                        ? "Closed " +
                          mysqlDate(
                            option[chartType].xAxis.data[
                              option[chartType].xAxis.data.length - 1
                            ]
                          )
                        : "Active"}
                    </span>
                  </Tooltip>
                </div>
              ) : (
                <></>
              )}
            </div>
          );
          // return <ReactEcharts option={option} />;
        })}
      </div>

      {/* <br />
      <br />
      <MostAdvancedTable propData={statsData} tblColumns={tblColumns} />
       */}
      {/* <br />
      <br />
      <DataGrid
        rows={statsData}
        columns={statsColumns(vaults)}
        pageSize={50}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
      /> */}
    </div>
  );
}
